inputs-search-switch
  div(class="form-group row { error: opts.errors }")
    input(type="hidden" value="{ opts.value }" name="{ opts.name }" )
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      .checkbox-fade.fade-in-primary
        label
          input(type="checkbox" value="{ opts.value }" onClick="{ this.onChange }" checked="{opts.value == opts.positive_value}")
          span.cr
            i.cr-icon.icofont.icofont-ui-check.txt-primary
          span { opts.positive_label }
  script(type="typescript").
    this.mixin('inputs.search.switch');
    console.log(this.opts)
